<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("AH") || "Engagements AH" }}</h1>
      <b-button
        size="sm"
        variant="success"
        class="button-succes-style ml-2 float-right mb-2"
        @click="goToCreate"
        ><font-awesome-icon icon="plus-circle" /> {{ $t("NEW") }}
      </b-button>
    </div>
    <div class="content">
      <div class="content-header">
        <searchBar
          :searchText="$t('SEARCH')"
          :searchFunc="searchAH"
          :filtre="{
            entreprise: isSuperAdmin ? currententreprise : null,
          }"
          :showFiltre="true"
          @returnValue="updateSearch($event)"
        ></searchBar>
        <!--------------------------------------- entrepriseModal --------------------------------------->
        <b-modal id="entrepriseModal" ref="entrepriseModal">
          <template #modal-header="{ close }">
            <h5>{{ $t("COMPANY_ID") }}</h5>
            <b-button size="sm" @click="close()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.028"
                height="17.028"
                viewBox="0 0 17.028 17.028"
              >
                <path
                  id="Icon_material-close"
                  data-name="Icon material-close"
                  d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                  transform="translate(-7.5 -7.5)"
                  fill="#393939"
                />
              </svg>
            </b-button>
          </template>

          <form @submit.prevent="hideModal('entrepriseModal')">
            <div class="center">
              <b-form-group :label="$t('COMPANY_ID')" v-if="this.isSuperAdmin">
                <searchInput
                  :list="getAllentreprises"
                  :loader="getentrepriseLoading"
                  label="lib"
                  :searchFunc="all_entreprises"
                  @searchfilter="selectentreprise($event)"
                ></searchInput>
              </b-form-group>
            </div>
          </form>
          <template #modal-footer>
            <div class="actionModel">
              <b-button variant="success" @click="setup(true)">
                <div class="block-spinner">
                  {{ $t("Appliquer") }}
                </div>
              </b-button>
            </div>
          </template>
        </b-modal>
        <!--------------------------------------- end entrepriseModal --------------------------------------->
      </div>
      <div class="filtre">
        <p class="table-count">
          {{ getTotalRowAH }} {{ $t("AH") || "Engagements" }}
        </p>
        <div class="productTrie" v-if="isSuperAdmin && currententreprise && currententreprise.lib">
          {{ currententreprise.lib }}
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="clearEntrepriseFilter()"
          />
        </div>
      </div>
      <div class="table-rapport-style w-100">
        <table>
          <thead>
            <tr>
              <th style="border-radius: 5px 0px 0px 0px">
                {{ $t("FACTURE") }} N°
              </th>
             
              <th v-if="isSuperAdmin">
                {{ $t("ENTREPRISES") }}
              </th>
              <th>
                {{ $t("Date d’engagement") }}
              </th>
              <th>
                {{ $t("Date prévue de réalisation") }}
              </th>
              <th>
                {{ $t("DOWNLOAD") }}
              </th>
              <th style="border-radius: 0px 5px 0px 0px" class="action_head"></th>
            </tr>
          </thead>

          <tbody>
            <tr
              role="row"
              class="ligneNormale"
              v-for="(data, i) in getAllAH"
              :key="i"
            >
              <td aria-colindex="1" role="cell">
                {{ getFactureNumber(data) }}
              </td>
             
              <td aria-colindex="3" role="cell" v-if="isSuperAdmin">
                {{ getEntrepriseName(data) }}
              </td>
              <td aria-colindex="4" role="cell">
                {{ formatDate(data.engagement_date || data.date_engagement) }}
              </td>
              <td aria-colindex="5" role="cell">
                {{ formatDate(data.completion_date || data.date_prevu_realisation) }}
              </td>
              <td aria-colindex="6" role="cell">
                <div class="grey" @click="handleDownload(data)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 20.944 20.944"
                  >
                    <g
                      id="Icon_feather-download"
                      data-name="Icon feather-download"
                      transform="translate(-3.5 -3.5)"
                    >
                      <path
                        id="Tracé_78100"
                        data-name="Tracé 78100"
                        d="M23.444,22.5v4.21a2.1,2.1,0,0,1-2.1,2.1H6.6a2.1,2.1,0,0,1-2.1-2.1V22.5"
                        transform="translate(0 -5.37)"
                        fill="none"
                        stroke="#28367a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        id="Tracé_78101"
                        data-name="Tracé 78101"
                        d="M10.5,15l5.262,5.262L21.025,15"
                        transform="translate(-1.79 -3.133)"
                        fill="none"
                        stroke="#28367a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        id="Tracé_78102"
                        data-name="Tracé 78102"
                        d="M18,17.13V4.5"
                        transform="translate(-4.028)"
                        fill="none"
                        stroke="#28367a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                </div>
              </td>
              <td aria-colindex="7" role="cell" class="action_col">
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="danger"
                  @click.prevent.stop="handleDelete(data)"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="success"
                  @click.prevent.stop="handleUpdate(data)"
                >
                  <font-awesome-icon icon="pencil-alt" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <deleteModalVue
        :loader="getAHLoading"
        :elemToDelete="delete_AH"
        :elemDelete="deleteAH"
        @updateList="setup(false)"
      ></deleteModalVue>

      <b-pagination
        v-model="page"
        :total-rows="getTotalRowAH"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
    </div>

    <div class="text-center center-spin">
      <b-spinner
        v-if="getAHLoading"
        variant="primary"
        label="Spinning"
        class="big-spin"
      ></b-spinner>
    </div>
    <CommentMarche to="/how-it-work/sousTraitant"></CommentMarche>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import deleteModalVue from "../components/ui/deleteModal.vue";
import searchBar from "../components/ui/searchBar.vue";
import searchInput from "../components/ui/searchInput.vue";
import CommentMarche from "../components/commentMarche.vue";

export default {
  components: {
    searchBar,
    searchInput,
    deleteModalVue,
    CommentMarche,
  },
  data() {
    return {
      search: "",
      delete_AH: null,
      page: 1,
      perPage: 10,
      currententreprise: null,
      filtre_entreprise: null,
      downloadUrl: "https://beta-api.batigo.fr/storage/",
      clientsMap: {}, // Map pour stocker les clients par ID
    };
  },
  methods: {
    ...mapActions([
      "allAH",
      "deleteAH",
      "all_entreprises",
      "storeAH",
      "updateAH",
      "downloadPdfAH",
      "all_clients",
    ]),

    updateSearch(s) {
      this.page = 1;
      this.search = s;
      this.setup(false);
    },

    async searchAH() {
      await this.setup(false);
    },

    clearEntrepriseFilter() {
      this.currententreprise = null;
      this.filtre_entreprise = null;
      this.setup(true);
    },

    selectentreprise(query) {
      if (query) {
        this.filtre_entreprise = query;
      } else {
        this.filtre_entreprise = {
          lib: null,
        };
      }
    },

    hideModal(ref) {
      this.$refs[ref].hide();
    },

    openModal(ref) {
      this.$refs[ref].show();
    },

    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD-MM-YYYY");
    },

    getFactureNumber(data) {
      // L'API retourne devis directement, pas facture.devis
      if (data.devis) {
        const devis = data.devis;
        return devis.numerofacture || devis.numerodevis || "-";
      }
      return "-";
    },

    getClientName(data) {
      // L'API retourne devis directement, mais le client n'est pas inclus dans la réponse
      // Si le client est déjà chargé dans devis.client
      if (data.devis && data.devis.client) {
        const client = data.devis.client;
        return `${client.prenom || ""} ${client.nom || ""}`.trim() || "-";
      }
      // Essayer de trouver le client dans la map des clients chargés
      if (data.devis && data.devis.client_id && this.clientsMap[data.devis.client_id]) {
        const client = this.clientsMap[data.devis.client_id];
        return `${client.prenom || ""} ${client.nom || ""}`.trim() || "-";
      }
      // Si seulement client_id est disponible, on ne peut pas afficher le nom
      // L'API devrait inclure les données du client dans la réponse
      return "-";
    },

    getEntrepriseName(data) {
      // L'API retourne devis directement, mais l'entreprise n'est pas incluse dans la réponse
      // Il faudra peut-être le charger séparément ou l'API doit l'inclure
      if (data.devis && data.devis.entreprise) {
        return data.devis.entreprise.lib || "-";
      }
      return "-";
    },

    handleDelete(ah) {
      this.delete_AH = { ...ah };
      this.$root.$emit("bv::show::modal", "ModelDelete");
    },

    goToCreate() {
      this.$router.push("/AH/create");
    },

    handleUpdate(ah) {
      this.$router.push(`/AH/edit/${ah.id}`);
    },

    pagination(paginate) {
      this.page = paginate;
      this.setup(false);
    },

    async handleDownload(ah) {
      try {
        const response = await this.downloadPdfAH(ah.id);
        if (response && response.data) {
          const pdfData = response.data;
          // Ouvrir le PDF dans un nouvel onglet
          if (pdfData.download_url) {
            window.open(pdfData.download_url, "_blank");
          } else if (pdfData.pdf_path) {
            // Si l'API retourne seulement le chemin, construire l'URL complète
            const downloadUrl = this.downloadUrl || "https://beta-api.batigo.fr/storage/";
            window.open(downloadUrl + pdfData.pdf_path.replace("storage/app/public/", ""), "_blank");
          }
        }
      } catch (error) {
        console.error("Error downloading AH PDF:", error);
        alert(error?.response?.data?.message || error?.message || "Une erreur est survenue lors du téléchargement.");
      }
    },
    async loadClients() {
      try {
        // Charger tous les clients pour pouvoir les mapper aux engagements AH
        await this.all_clients({ page: 1, per_page: 10000 });
        // Créer une map des clients par ID pour un accès rapide
        if (this.getAllclients && Array.isArray(this.getAllclients)) {
          this.clientsMap = {};
          this.getAllclients.forEach((client) => {
            this.clientsMap[client.id] = client;
          });
        }
      } catch (error) {
        console.error("Error loading clients:", error);
      }
    },
    async setup(refresh = false) {
      if (refresh) this.page = 1;

      this.currententreprise = this.filtre_entreprise;
      if (this.$refs["entrepriseModal"]) {
        this.$refs["entrepriseModal"].hide();
      }

      const params = {
        page: this.page,
        per_page: this.perPage,
        search: this.search || null,
      };

      if (this.currententreprise) {
        if (typeof this.currententreprise === 'object' && this.currententreprise.id) {
          params.entreprise_id = this.currententreprise.id;
        } else if (typeof this.currententreprise === 'number' || typeof this.currententreprise === 'string') {
          params.entreprise_id = this.currententreprise;
        } else {
          params.entreprise = this.currententreprise;
        }
      } else if (!this.isSuperAdmin && this.getOnlineUser) {
        if (this.getOnlineUser.entreprise) {
          if (typeof this.getOnlineUser.entreprise === 'object' && this.getOnlineUser.entreprise.id) {
            params.entreprise_id = this.getOnlineUser.entreprise.id;
          } else if (typeof this.getOnlineUser.entreprise === 'number' || typeof this.getOnlineUser.entreprise === 'string') {
            params.entreprise_id = this.getOnlineUser.entreprise;
          } else {
            params.entreprise = this.getOnlineUser.entreprise;
          }
        }
      }

      // Attendre que l'API AH soit terminée avant de continuer
      await this.allAH(params);
    },
  },

  async mounted() {
    // Charger d'abord les AH (le loading sera affiché via getAHLoading)
    await this.setup(true);
    
    // Charger les clients en arrière-plan (sans bloquer l'affichage)
    this.loadClients();
    
    // Charger les entreprises si super admin
    if (this.isSuperAdmin) {
      this.all_entreprises({
        page: 1,
        per_page: 1000,
      });
    }
  },

  computed: {
    ...mapGetters([
      "getAllAH",
      "getAHLoading",
      "getTotalRowAH",
      "getTabs",
      "getOnlineUser",
      "getAllentreprises",
      "getentrepriseLoading",
      "getAllclients",
    ]),
    isentrepriseAdmin() {
      return this.getOnlineUser.role == "user.entreprise-admin";
    },
    isCommercialBatigo() {
      return this.getOnlineUser.role == "user.commercial-batigo";
    },
    isAssistant() {
      return this.getOnlineUser.role == "user.assistant";
    },
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group .icon-balance {
  top: 8px;
}

.prodimg {
  padding: 8px;
  background: #465081;
  max-width: 64px;
  max-height: 64px;
}

.option {
  display: flex;
  align-items: center;

  .option__image {
    background-color: #465081;
    padding: 4px;
    max-height: 42px;
    max-width: 42px;
  }
}

.content p {
  font-size: 12px;
  font-weight: 500;
  padding: 3px 0;
  margin: 0;
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}

.actionModel {
  position: relative;
  padding: 15px 0 0;
  display: flex;
  flex-flow: column;
  align-items: center;

  .messageError {
    color: #e4261b;
    font-size: 16px;
    background-color: #fff;
    border-color: #fff;
  }

  .block-spinner {
    display: flex;
    justify-content: center;
  }

  .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.detailClient {
  background-color: #fff;
  box-shadow: 1px 1px 24px #00000019;

  .clientTop {
    padding: 16px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #707070;

    .prodimg {
      max-width: 185px;
      max-height: 231px;
    }
  }

  h4 {
    color: #28367a;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  p {
    color: #515151;
    font-size: 16px;
    font-weight: 500;
  }
}

.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

.image-conteneur {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .block {
    cursor: pointer;
    width: 25%;
    margin-bottom: 16px;
    padding: 15px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    .image-content img {
      width: 100%;
    }

    p {
      margin: 0;
      text-align: center;
      color: #303030;
    }
  }
}

.galerieImage {
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 20%;
    max-height: 100px;
  }
}

.grey {
  background-color: #f5f6f8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  margin: 0 auto;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e9ecef;
  }
}
</style>

